import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { type IDropdownItem, InputRadio, Tooltip } from 'shared/ui'
import styles from './styles.module.scss'

type IPaymentOptionsProps = {
  items: IDropdownItem[]
  selectedValue: string
  onSelect?: (id: string) => void
}

export const PaymentOptions = observer(
  ({ items, selectedValue, onSelect }: IPaymentOptionsProps) => {
    return (
      <div className={styles.paymentOptions}>
        {items.map((item) => {
          const isChecked = selectedValue === item.id
          return (
            <Tooltip
              {...(item.tooltipProps ? item.tooltipProps : undefined)}
              fullWidth
              placement='top'
              key={item.id}
            >
              <InputRadio
                key={item.id}
                label={item.label}
                checked={isChecked}
                onChecked={() => onSelect?.(item.id.toString())}
                className={classNames(styles.radioButton, {
                  [styles.checked]: isChecked,
                  [styles.disabled]: item.disabled,
                })}
                radioSize='small'
                disabled={item.disabled}
              />
            </Tooltip>
          )
        })}
      </div>
    )
  }
)
